import React from 'react';

function ClientsBenefitsIcon5() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <path
        fill="#1B1F2C"
        d="M31.5 16c0 8.56-6.94 15.5-15.5 15.5C7.44 31.5.5 24.56.5 16 .5 7.44 7.44.5 16 .5 24.56.5 31.5 7.44 31.5 16zm-17.293 8.207l11.5-11.5a1 1 0 000-1.414l-1.414-1.414a1 1 0 00-1.414 0L13.5 19.257 9.121 14.88a1 1 0 00-1.414 0l-1.414 1.414a1 1 0 000 1.414l6.5 6.5a1 1 0 001.414 0z"
      />
    </svg>
  );
}

export default ClientsBenefitsIcon5;
